import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { OrderBillBus } from '@app/cp/shared/models/OrderBillBus';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { OrderBillDetailsBus } from '@app/cp/shared/models/OrderBillDetailsBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'bill-details',
    templateUrl: './bill-details.component.html',
    styleUrls: ['./bill-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BillDetailsComponent extends BaseGridEditLineComponent<OrderBillBus, null, OrderService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "OrderBillBus";
    }
    @Input() testCode: string = "Z";
    test() {
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'orderBillId': new UntypedFormControl(),
            'orderId': new UntypedFormControl(),
            'amountBilled': new UntypedFormControl(),
            'referenceNumber': new UntypedFormControl(),
            'orderBillStatusId': new UntypedFormControl(),
            'receivedById': new UntypedFormControl(),
            'dateReceived': new UntypedFormControl(),
        });

    }
    setForm() {
        this.editForm.patchValue({
            orderBillId: this.selectedData.orderBillId,
            orderId: this.selectedData.orderId,
            amountBilled: this.selectedData.amountBilled,
            referenceNumber: this.selectedData.referenceNumber,
            orderBillStatusId: this.selectedData.orderBillStatusId,
            receivedById: this.selectedData.receivedById,
            dateReceived: this.selectedData.dateReceived
        });
    }
    public getAll(): any {
        return _.cloneDeep(this.gridData);
    }
    public getDeletedItems() {
        return _.cloneDeep(this.deletedItems);
    }
    amountBilledChanged(e, dataItem, edtForm) {
        //let orderBillId: any = CommonValues.Guid_Empty;
        //this.svc_data.getOrderBillDetailsGrid(this.parentId, orderBillId).subscribe((info: BaseMessageInfo) => {

        //});
    }
    onTabSelect(e: any) { }
    //save(data: OrderBillBus) {
    //}
    refNoBlur(e, dataItem: OrderBillBus, edtForm, rowIndex) {
        let orderBillId: any = CommonValues.Guid_Empty;
        this.svc_data.getOrderBillDetailsGrid(this._parentId, orderBillId).subscribe((info: BaseMessageInfo) => {

            let hasData: boolean = !info.saveError && CommonFunctions.hasValue(info.primaryReturn);
            if (hasData) {
//                let busObj: OrderBillBus = dataItem;
                dataItem.orderBillStatusId = CommonValues.OrderBillStatus_Received;
                dataItem.dateReceived = DateFunctions.getDateNow();
                dataItem.receivedById = this.globals.personId;
                var arr = [];
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let detObj = new OrderBillDetailsBus(info.primaryReturn[i]);
                    arr.push(detObj);
                }
                dataItem.orderBillDetails = arr;
                this.saveCurrent();
                this.grid.expandRow(rowIndex);
                this.showDetail = true;
                //this.gridData.push(busObj);
            }

        });

    }

    amountBilledBlur(e, dataItem: OrderBillBus, edtForm, rowIndex) {
//        let orderBillId: any = CommonValues.Guid_Empty;
//        this.svc_data.getOrderBillDetailsGrid(this._parentId, orderBillId).subscribe((info: BaseMessageInfo) => {
//            let hasData: boolean = !info.saveError && CommonFunctions.hasValue(info.primaryReturn);
//            if (hasData) {
////                let busObj: OrderBillBus = dataItem;
//                dataItem.orderBillStatusId = CommonValues.OrderBillStatus_Received;
//                dataItem.dateReceived = DateFunctions.getDateNow();
//                dataItem.receivedById = this.globals.personId;
//                var arr = [];
//                for (let i = 0; i < info.primaryReturn.length; i++) {
//                    let detObj = new OrderBillDetailsBus(info.primaryReturn[i]);
//                    arr.push(detObj);
//                }
//                dataItem.orderBillDetails = arr;
//                this.grid.expandRow(rowIndex);
//                //this.gridData.push(busObj);
//            }
//            this.showDetail = true;

//        });
    }
    showDetail: boolean = false;
}
